import { ReactNode } from 'react';
import jupyterIcon from '../../assets/jupyter.png';
import harborIcon from '../../assets/harbor.png';
import argocdIcon from '../../assets/argocd.png';
import argoworkflowsIcon from '../../assets/argo-workflows.png';
import vaultIcon from '../../assets/vault.png';

export interface Service {
  url: string;
  label: string;
  icon: string;
  description?: string;
  documentation?: string;
  staffOnly?: boolean;
  adminOnly?: boolean;
}

export interface Tool {
  url: string;
  label: string;
  icon: ReactNode;
  description?: string;
  documentation?: string;
}

export const services: Service[] = [
  {
    url: 'https://hub.comp-teach.qmul.ac.uk',
    label: 'JupyterHub',
    icon: jupyterIcon,
    description: 'Notebooks and Interactive Computing',
    documentation: 'https://jupyterhub.readthedocs.io',
  },
  {
    url: 'https://harbor.a.comp-teach.qmul.ac.uk',
    label: 'Harbor',
    icon: harborIcon,
    description: 'Container Registry',
    documentation: 'https://goharbor.io/docs',
    staffOnly: true,
  },
  {
    url: 'https://argocd.a.comp-teach.qmul.ac.uk',
    adminOnly: true,
    label: 'ArgoCD',
    icon: argocdIcon,
    description: 'GitOps Continuous Delivery',
    documentation: 'https://argo-cd.readthedocs.io',
    staffOnly: true,
  },
  {
    url: 'https://argo.a.comp-teach.qmul.ac.uk',
    label: 'Argo Workflows',
    icon: argoworkflowsIcon,
    description: 'Workflow Engine',
    documentation: 'https://argoproj.github.io/argo-workflows',
    staffOnly: true,
  },
  {
    url: 'https://vault.c.comp-teach.qmul.ac.uk/ui/vault/dashboard',
    label: 'Vault',
    icon: vaultIcon,
    description: 'Secrets Management',
    documentation: 'https://www.vaultproject.io/docs',
    staffOnly: true,
  },
]; 
